import { defineMessages } from "react-intl";
const messages = defineMessages({
    createUser: {
        id: "app.users.users.createUser.createUser.title.text",
        defaultMessage: "Add New User",
    },
    createUserAction: {
        id: "app.users.users.createUser.createUser.action.text",
        defaultMessage: "Create",
    },
    editUserAction: {
        id: "app.users.users.createUser.editUser.action.text",
        defaultMessage: "Save",
    },
    createUserSuccess: {
        id: "app.users.users.createUser.createUser.success.text",
        defaultMessage: "User created successfully.",
    },
    updateUserSuccess: {
        id: "app.users.users.updateUser.updateUser.success.text",
        defaultMessage: "User updated successfully.",
    },
    selectCommunityError: {
        id: "app.users.users.createUser.selectCommunity.error.text",
        defaultMessage: "Select at least one Community",
    },
    userRole: {
        id: "app.users.users.createUser.form.role.text",
        defaultMessage: "Select Role",
    },
    userFormName: {
        id: "app.users.users.createUser.form.name.text",
        defaultMessage: "Name",
    },
    userFormOrganization: {
        id: "app.users.users.createUser.form.organization.text",
        defaultMessage: "Select Organization",
    },
    userFormOrganizationPlaceholder: {
        id: "app.users.users.createUser.form.organization.placeholder",
        defaultMessage: "No Organization Selected",
    },
    userFormEmail: {
        id: "app.users.users.createUser.form.email.text",
        defaultMessage: "Email Address",
    },
    userFormEmailPlaceholder: {
        id: "app.users.users.createUser.form.email.placeholder",
        defaultMessage: "userEmail@userDomain.com",
    },
    userFormPhone: {
        id: "app.users.users.createUser.form.phone.text",
        defaultMessage: "Phone Number",
    },
    userFormPhonePlaceholder: {
        id: "app.users.users.createUser.form.phone.placeholder",
        defaultMessage: "xxx-xxx-xxx",
    },
    userFormCommunities: {
        id: "app.users.users.createUser.form.communities.text",
        defaultMessage: "Select Communities",
    },
    userFormCommunitiesPlaceholder: {
        id: "app.users.users.createUser.form.communities.placeholder",
        defaultMessage: "No Communities Selected",
    },
    userFormEditingPrivileges: {
        id: "app.users.users.createUser.form.editingPrivileges.text",
        defaultMessage: "Enable editing privilege",
    },
    userNameRequired: {
        id: "app.users.users.createUser.nameRequired.text",
        defaultMessage: "Name is required",
    },
    userPhoneRequired: {
        id: "app.users.users.createUser.phoneRequired.text",
        defaultMessage: "Phone number is required",
    },
    userEmailRequired: {
        id: "app.users.users.createUser.emailRequired.text",
        defaultMessage: "Email is required",
    },
    userRoleRequired: {
        id: "app.users.users.createUser.roleRequired.text",
        defaultMessage: "Role is required",
    },
    userOrganizationRequired: {
        id: "app.users.users.createUser.organizationRequired.text",
        defaultMessage: "Organization is required",
    },
    userCommunityRequired: {
        id: "app.users.users.createUser.CommunityRequired.text",
        defaultMessage: "Community is required",
    },
    userPropertyRequired: {
        id: "app.users.users.createUser.propertyRequired.text",
        defaultMessage: "At least one property is required",
    },
    userEmailInvalid: {
        id: "app.users.users.createUser.emailInvalid.text",
        defaultMessage: "Enter an email in userEmail@userDomain.com format",
    },
    userNumberFormat: {
        id: "app.users.users.createUser.numberFormat.text",
        defaultMessage: "Enter mobile number in 999-999-9999 format",
    },
    userNameLength: {
        id: "app.users.users.createUser.nameLength.text",
        defaultMessage: "User name should contain at least 5 characters",
    },
});
export default messages;
